module.exports = __webpack_public_path__ + "static/media/notification.bb775fa7.svg";